import {ListTableDataSourceFragment} from "@/shared/ListTableDataSourceFragment";
import {LABELER_TASK_CATEGORY_KTS, LabelerTask, LabelerTasks, ResourceData} from "@/fyneai-shared/types";
import {TableDataContainer, TableDataRow} from "@/shared/TableDataContainer";
import {TableDataSourceFragmentProps} from "@/shared/TableDataSourceFragment";
import React from "react";
import {TableData} from "@/shared/tabledata";
import {PageFragment, PageFragmentStyleFlags} from "../../../../shared/PageFragment";
import {Action, ACTION_SPACE, ActionBase, CreateActionsArgs} from "../../../../shared/types";
import {AddOutlined} from "@mui/icons-material";
import {EditTaskHelper} from "./EditTaskHelper";
import {SelectImportHelper} from "../imports/SelectImportHelper";
import {BaseApp} from "@/shared/BaseApp";
import {EditAssignmentHelper} from "../assignments/EditAssignmentHelper";

class LabelerTaskRow implements TableDataRow {

  constructor(readonly loader: LabelerTasks) {
  }

  @TableData({name: "Category"})
  category: string;

  @TableData({name: "Name", cellSize: "xlarge"})
  name: string;

  @TableData({name: "Multiple", cellSize: "medium"})
  multiple: string;

  @TableData({name: "Description", cellSize: "xxlarge"})
  description: string;

  @TableData({
    name: "Imports",
    type: "string",
    cellSize: "xlarge"
  })
  info: string;

  @TableData({
    name: "Actions",
    type: "actions",
    actions: (event, args: CreateActionsArgs<LabelerTask, LabelerTaskRow>) => {
      const tasks = args.rowValue.__row.loader;
      const task = args.data as LabelerTask;
      const datasetId = args.path.params.dataset_id;
      return [
        new Action("Edit Task", () => EditTaskHelper.editTask(datasetId, task)),
        new Action("Duplicate Task", () => EditTaskHelper.duplicateTask(datasetId, task)),
        new Action("Attach Import", () => {
          SelectImportHelper.selectImport(datasetId, task.imports, items => {
            task.imports = items;
            task.importIds = items.map(item => item.id);
            tasks.addListItem(task)
              .then(() => BaseApp.CONTEXT.showToast("Imports updated."));
          });
        }),
        new Action("Assign Task", () => EditAssignmentHelper.editAssignment(task.assignment)),
        new Action("Delete Task", () => EditTaskHelper.deleteTask(datasetId, task))
          .makeDestructive(),
      ];
    },
  })
  actions: any;
}

export type TasksFragmentProps = TableDataSourceFragmentProps & {
  datasetId: string,
}

export class TasksFragment extends ListTableDataSourceFragment<LabelerTask, LabelerTaskRow, LabelerTasks, TasksFragmentProps> {

  private readonly actions: ActionBase[] = [
    ACTION_SPACE,
    new Action("Create task", () => {
      EditTaskHelper.addTask(this.props.datasetId);
    }, AddOutlined).setVariant("contained"),
  ]

  constructor(props: TasksFragmentProps, context: any) {
    super(props, context, new LabelerTasks(ResourceData.projectId(), props.datasetId));
  }

  protected styleFlags(): number | PageFragmentStyleFlags {
    return PageFragment.STYLE_TOOLBAR_TYPE_FLAG;
  }

  protected getTitle(): string | null | undefined {
    return "Tasks";
  }

  protected getToolbar(toolbarModeId: string | null): React.ReactElement {
    return this.renderToolbarButtonsInToolbarContainerEx(this.actions);
  }

  applyTableDataToRow(data: LabelerTask, row: LabelerTaskRow): void {
    row.category = LABELER_TASK_CATEGORY_KTS.findText(data.category);
    row.name = data.name;
    row.multiple = data.multiple ? "Yes" : "No";
    row.description = data.description || "-";
    row.info = `${data.importIds.length} Imports / ${data.cases.length} Cases`;
  }

  createTableDataRow(): LabelerTaskRow {
    return new LabelerTaskRow(this.loader);
  }

  onTableCellChanged(data: LabelerTask, cellId: string, value: any): void {
  }

  onTableDataSelected(data: LabelerTask): void {
    this.props.path.navigate(`tasks/${data.id}`);
  }

  renderContent(): React.ReactElement {
    return <TableDataContainer
      path={this.props.path}
      data={this.loader.getListItems()}
      source={this}/>;
  }
}